import ImageCompressor from "js-image-compressor";

//压缩图片
export function compressionImage(file,width,height) {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-new
    new ImageCompressor({
      file: file,
      quality: 1,
      maxWidth: width,
      maxHeight: height,
      redressOrientation: false,
      // 压缩前回调
      beforeCompress: function (result) {
        console.log('压缩之前图片尺寸大小: ', result.size)
        console.log('mime 类型: ', result.type)
      },
      success: function (result) {
        console.log('压缩之后图片尺寸大小: ', result.size)
        console.log('mime 类型: ', result.type)
        console.log('实际压缩率： ', ((file.size - result.size) / file.size * 100).toFixed(2) + '%')
        resolve(result)
      },
      error (e) {
        reject(e)
      }
    })
  })
}

//将base64转换为file文件
export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.dataURL.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {type:mime});
}

// 将url转换为base64
export function getBase64Image(img,orgWidth,orgHeight) {
  var demoCanvas = document.createElement("canvas");
  demoCanvas.width = img.width;
  demoCanvas.height = img.height;
  var ctx = demoCanvas.getContext("2d");
  ctx.drawImage(img, 0, 0, orgWidth, orgHeight);
  var ext = img.src.substring(img.src.lastIndexOf(".")+1).toLowerCase();
  var dataURL = demoCanvas.toDataURL("image/"+ext);
  return {
    dataURL: dataURL,
    type: "image/"+ext
  };
}

export function fileProcess(fileUrl, filename) {
  return new Promise((resolve, reject) =>{
    var demoImg = document.createElement("img")
    demoImg.src = fileUrl
    var image = new Image();
    // 给img加上随机值一部分情况下能解决跨域
    // image.src = img + '?time=' + new Date().valueOf();
    image.src = fileUrl;
    // 允许跨域操作
    image.setAttribute("crossOrigin", 'anonymous');
    image.onload = function () {
      var base64 = getBase64Image(image,image.width,image.height);
      var newFile = dataURLtoFile(base64, filename);
      let fileList = {
        name: filename,
        url: fileUrl,
        raw: newFile,
        size:newFile.size,
        ext:newFile.type.substring(6,newFile.type.length),
        width:image.width,
        height:image.height,
        w:image.width,
        h:image.height
      };
      resolve(fileList)
    }
  })

}
